module.exports = __webpack_public_path__ + "static/img/akum_800_35.e3b7c8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_35.svg
// module id = W6hz
// module chunks = 1